export const SOCKET = 'wss://norma.nomoreparties.space/orders'

export const ALL_ORDERS = '/all'